module.exports = "/images/ico-classic-blue.png?8cdcaab1773f95c2e056b65f8dcfd867";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/ico-classic-blue.png
// module id = +PSf
// module chunks = 1